import { render, staticRenderFns } from "./UserOrg.vue?vue&type=template&id=9e09ed90&scoped=true&"
import script from "./UserOrg.vue?vue&type=script&lang=js&"
export * from "./UserOrg.vue?vue&type=script&lang=js&"
import style0 from "./UserOrg.vue?vue&type=style&index=0&id=9e09ed90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e09ed90",
  null
  
)

export default component.exports